<template>
  <modal :title="'Greetins Default'">
    <template #content>
      <loadArea
        v-if="greetingsDefaults == null || languages == null"
      ></loadArea>
      <div class="myTable" v-if="model.length > 0">
        <table class="table table-bordered m-0">
          <thead class="colorTable">
            <tr>
              <th>Dil</th>
              <th>Ünvan</th>
              <th>Address Greeting</th>
              <th>Letter Greeting</th>
            </tr>
          </thead>
          <tbody>
            <!-- <template v-for="language in languages" :key="language.LanguageCode"> -->
            <tr v-for="item in model" :key="item">
              <td>
                <!-- 
                          <img
                            height="19"
                            :src="
                              '/flags/' +item.LanguageCode.toLowerCase() +
                                '.svg'
                            "
                          /> -->
                {{
                  languages.filter(
                    (x) => x.LanguageCode == item.LanguageCode
                  )[0].Name
                }}
              </td>
              <td>
                <template v-if="item.Gender == 1">Mr</template>
                <template v-if="item.Gender == 2">Mrs</template>
                <template v-if="item.Gender == 3">Chd</template>
                <template v-if="item.Gender == 4">Inf</template>
              </td>
              <td>
                <select v-model="item.AddressGreeting">
                  <option
                    :value="g.Text"
                    v-for="g in getgreetings(0, item.LanguageCode, item.Gender)"
                    :key="g.Text"
                    >{{ g.Text }}</option
                  >
                </select>
              </td>
              <td>
                <select v-model="item.LetterGreeting">
                  <option
                    :value="g.Text"
                    v-for="g in getgreetings(1, item.LanguageCode, item.Gender)"
                    :key="g.Text"
                    >{{ g.Text }}</option
                  >
                </select>
              </td>
            </tr>
            <!-- </template> -->
          </tbody>
        </table>
      </div>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process"
        >Save</Btn
      >
    </template>
  </modal>
</template>

<script>
// import axios from "axios";
export default {
  name: "greetingsDefaults",
  props: {
    hotel: {
      type: Object,
    },
  },
  data() {
    return {
      model: [],
      greetings: null,
      greetingsDefaults: null,
      languages: null,
      process: false,
    };
  },
  created() {
    console.log("this.hotel", this.hotel);
    this.$appAxiosAdmin
      .get("pms/13/GetFormPart/" + this.hotel.Id + "/Greetings")
      .then((response) => {
        this.greetings = response.data;
        this.set();
      });
    this.$appAxiosAdmin
      .get("pms/13/GetFormPart/" + this.hotel.Id + "/Languages")
      .then((response) => {
        this.languages = response.data;
        this.set();
      });

    this.$appAxiosAdmin
      .get("pms/13/GetFormPart/" + this.hotel.Id + "/GreetingsDefaults")
      .then((response) => {
        this.greetingsDefaults = response.data;
        this.set();
      }).catch(()=>{
        this.greetingsDefaults=[];
        this.set();
      });
  },
  methods: {
    set() {
      if (
        this.greetings == null ||
        this.languages == null ||
        this.greetingsDefaults == null
      ) {
        return false;
      }
      this.languages.forEach((language) => {
        for (let index = 1; index < 5; index++) {
          let greeting = this.greetingsDefaults.filter(
            (x) => x.Gender == index && x.LanguageCode == language.LanguageCode
          );
          this.model.push({
            LanguageCode: language.LanguageCode,
            Gender: index,
            AddressGreeting:
              greeting.length > 0 ? greeting[0].AddressGreeting : "",
            LetterGreeting:
              greeting.length > 0 ? greeting[0].LetterGreeting : "",
          });
        }
      });
    },
    getgreetings(type = 0, languageCode, gender = 1) {
      let data = this.greetings.filter(
        (x) =>
          x.LanguageCode == languageCode &&
          x.Type == type &&
          (gender > 2 || x.Gender == 0 || x.Gender == gender)
      );
    //   if (data.length == 0) {
    //     data = this.greetings.filter(
    //       (x) => x.LanguageCode == "EN" && x.Type == type &&
    //       (gender > 2 || x.Gender == 0 || x.Gender == gender)
    //     );
    //   }
      return data;
    },
    save(){
              this.process = true;
          this.$appAxiosAdmin
            .post('pms/13/UpsertFidelioGreetings/'+this.hotel.Id, this.model)
            .then(() => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:"Greetings saved successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
    }
  },
};
</script>

<style scoped>
    td{
        position: relative;
    }
    td select{
        position: absolute;
        left:0;
        top:0;
        border: none;
        background: none;
        width:100%;
    }
</style>
